import React, { useEffect, useState, useCallback } from 'react';
import {
  Checkmark20Regular,
  Dismiss20Regular,
} from '@fluentui/react-icons';
import { ColorControl } from './color-control';
import { ImageWithShimmer } from '../../../image-with-shimmer';

const ImageToUpdate = (props) => {
  const {
    targetImage,
    isDrawing,
  } = props;

  return (
    <ImageWithShimmer
      targetImage={targetImage}
      showShimmer={isDrawing}
    />
  );
};

export const useColorControlViewFactoryWithState = (props) => {
  const {
    selectedImageSrc,
    imageUrlWithoutBackground,
    drawColorBackground,
    imageUrlWithColoredBackground,
    goToImageAdjustView,
    image,
    i18n,
    applyImage,
    logger,
  } = props;

  const [color, setColor] = useState('#4285f4');
  const [lastColor, setLastColor] = useState(color);
  const [isDrawing, setIsDrawing] = useState(false);

  const draw = (targetColor) => {
    setLastColor(color);
    setColor(targetColor);
  };

  useEffect(() => {
    setIsDrawing(true);
    drawColorBackground(color, image.width, image.height).then(() => { setIsDrawing(false); });
  }, [color, drawColorBackground, image.height, image.width]);

  const updateImage = useCallback(() => {
    logger.logTrace('background change: apply the color background', { color });
    applyImage({ url: imageUrlWithColoredBackground }, true);
  }, [applyImage, color, imageUrlWithColoredBackground, logger]);

  return {
    colorControlView: (
      <ColorControl
        {...props}
        lastColor={lastColor}
        color={color}
        draw={draw}
      />
    ),
    buttonsConfig: [{
      text: i18n.getString(_TL_('Apply')),
      icon: Checkmark20Regular,
      onClick: updateImage,
      disabled: isDrawing,
    }, {
      text: i18n.getString(_TL_('Cancel')),
      icon: Dismiss20Regular,
      onClick: goToImageAdjustView,
    }],
    imageView: (<ImageToUpdate
      targetImage={imageUrlWithColoredBackground || selectedImageSrc || imageUrlWithoutBackground}
      isDrawing={isDrawing}
    />),
  };
};
